import type { AuditSearch } from './search';

export const auditKeys = {
  all: ['audit'] as const,
  list: (search: AuditSearch) => [...auditKeys.all, 'list', search] as const,
  count: () => [...auditKeys.all, 'count'] as const,
  people: () => [...auditKeys.all, 'people'] as const,
  ruleDecisions: (from: string) => [...auditKeys.all, 'rule-decisions', from] as const,
};
